import React from "react";

const SvgComponent = props => (
  <svg width={43.17} height={36.589} viewBox="0 0 43.17 36.589" {...props}>
    <g fill="#83a5b3">
      <path d="M10.627 31.394a1.494 1.494 0 000-2.986H5.102a1.494 1.494 0 100 2.986h5.525zM21.717 31.394a1.492 1.492 0 000-2.986h-5.525a1.494 1.494 0 100 2.986h5.525zM32.808 31.394a1.492 1.492 0 000-2.986h-5.525a1.492 1.492 0 000 2.986h5.525zM16.152 36.589a1.492 1.492 0 000-2.984h-5.525a1.492 1.492 0 100 2.984h5.525zM27.244 36.589a1.493 1.493 0 000-2.984h-5.527c-.826 0-1.492.668-1.492 1.492s.666 1.492 1.492 1.492h5.527zM38.332 36.589c.824 0 1.494-.668 1.494-1.492s-.67-1.492-1.494-1.492h-5.524a1.492 1.492 0 000 2.984h5.524zM35.629 25.46a7.54 7.54 0 007.541-7.542s.037-7.533-7.892-7.533c-1.715-7.059-8.315-7.417-10.168-6.918C23.103 1.468 19.758 0 16.375 0 9.672 0 4.178 5.185 3.684 11.764A7.336 7.336 0 007.338 25.46h28.291zM7.971 22.651c-2.74 0-4.762-1.983-4.762-4.549 0-2.096 1.332-3.934 3.412-4.561.246-9.904 8.947-10.41 9.914-10.41 2.873 0 5.725 1.41 7.562 3.497 3.709-1.219 8.795 1.641 8.227 7.172 1.447-.587 2.896-.542 3.312-.542 2.076 0 4.589 1.82 4.589 4.802a4.592 4.592 0 01-4.589 4.59l-27.665.001z" />
    </g>
  </svg>
);

export default __webpack_public_path__ + "static/media/50n.dc59f73d.svg";
export { SvgComponent as ReactComponent };



// WEBPACK FOOTER //
// ./src/assets/weather-icons/50n.svg